import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';

import { Newsletter } from '../../components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer app__bg">
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">20, Hageoma 7-Gil, Wansan-Gu, Jeonju-Si</p>
        <p className="p__opensans">+1 212-344-1230</p>
        <p className="p__opensans">+1 212-344-1230</p>
      </div>
      <div className="app__footer-links_logo">
        <img src={images.elpis} alt="footer_logo" />
        <p className="p__opensans">"The best way to find yourself is to lose yourself in the service of others."</p>
        <img src={images.leaf} alt="leaf" className="leaf__img" style={{marginTop: 15}}/>
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>
      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">10:00 Am - 06:00 Pm</p>
        <p className="p__opensans">Saturday-Sunday</p>
        <p className="p__opensans">Closed</p>
      </div>
    </div>
    <div className="footer__copyright">
      <p className="p__opensans">2022 Elpis. All Rights reserved.</p>
    </div>
  </div>
);

export default Footer;
